import { useSelector } from 'react-redux';

const TCDetailsFromCompanyDetailsWidget = ({ token }) => {
	const companyTermsAndCondition = useSelector(
		({ fuse }) => fuse.form.companyDetailsResponse?.value?.companyTermsConditionsViewModel?.termsAndConditions
	);
	const channelTermsAndConditions = useSelector(
		({ fuse }) => fuse.form.channelSettings?.value?.company?.companyTermsConditionsViewModel?.termsAndConditions
	);

	return (
		<div>
			<div className="flex flex-col">
				<div
					dangerouslySetInnerHTML={{
						__html: token === 'TOKEN' ? companyTermsAndCondition : channelTermsAndConditions
					}}
				/>
			</div>
		</div>
	);
};

export default TCDetailsFromCompanyDetailsWidget;
